(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__variantButtonsReflowFixInit) return;
    window.__variantButtonsReflowFixInit = true;

    // .variant-option--buttons を使っているすべてのボタングループ
    // （サイズ選択・寄付する/しない 選択 等）を対象に強制リフローする
    const forceReflow = () => {
      document.querySelectorAll('.variant-option--buttons').forEach((el) => {
        const prevDisplay = el.style.display;
        el.style.display = 'none';
        // 読み取ることでレイアウトを強制的に再計算させる
        void el.offsetHeight;
        el.style.display = prevDisplay;
      });
    };

    const scheduleReflow = () => {
      requestAnimationFrame(forceReflow);
    };

    // ページが表示状態に戻ったとき（画面ロック解除・タブ復帰など）
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') scheduleReflow();
    });

    // bfcacheから復元されたとき
    window.addEventListener('pageshow', scheduleReflow);

    // Webフォント読み込み完了時（初回表示時の崩れ対策）
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleReflow);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
